import { Object3D, Vector2, Vector3 } from 'three';
import { BUTTON_PRIMARY_COLOR, BUTTON_PRIMARY_TEXT_COLOR, PRIMARY_TEXT_COLOR, WINDOW_SPACER_COLOR } from '../styleConfig';
import { FuturisticWindow } from './FuturisticWindow';
import { ActionControllerEventName, ButtonComponent, ParentEvent, TextComponent, Tween, ViewerModule } from '@verybigthings/vbt-webvr-framework';
export default class Modal extends ViewerModule {
    constructor() {
        super();
        this.addObject(this.background = new FuturisticWindow({
            size: new Vector2(6, 3.5),
            radius: 0.3,
            type: 1,
            hasSideImage: false
        }));
        this.addObject(this.header = new TextComponent({
            size: new Vector2(1.1, 1.1),
            pxSize: new Vector2(64, 64),
            text: {
                style: { family: 'Nunito', weight: '700', size: '21px', color: PRIMARY_TEXT_COLOR.getStyle() },
                value: '',
                autoWrappingHorizontal: true,
                autoWrapping: true,
                margin: { bottom: 18 }
            },
            background: { color: WINDOW_SPACER_COLOR.getStyle() }
        }));
        this.header.uiObject.position.z = 0.01;
        this.header.uiObject.position.y = 0.95;
        this.addObject(this.text = new TextComponent({
            size: new Vector2(8, 3),
            pxSize: new Vector2(512, 192).multiplyScalar(window['quality'] === 'very low' ? 1 : 1),
            text: {
                style: { size: `${20 * (window['quality'] === 'very low' ? 1 : 1)}px`, family: 'Nunito', weight: '400', color: PRIMARY_TEXT_COLOR.getStyle() },
                value: '',
                autoWrappingHorizontal: true,
                lineHeight: 26 * (window['quality'] === 'very low' ? 1 : 1),
                align: 'center',
                autoWrapping: true,
                margin: { bottom: 12 }
            },
            background: { color: WINDOW_SPACER_COLOR.getStyle() }
        }));
        this.text.uiObject.position.y = -0.1;
        this.text.uiObject.position.z = 0.01;
        this.button = new ButtonComponent({
            type: 'flat',
            size: new Vector3(6, 6, 1),
            sizePx: new Vector2(256, 256),
            bordRadius: 0.1,
            background: { color: BUTTON_PRIMARY_COLOR.getStyle() },
            text: {
                value: 'OK'.toUpperCase(),
                lineHeight: 12,
                style: { size: '16px', color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                margin: { top: 10, right: 45, bottom: 10, left: 45 },
            }
        });
        this.button.on(ActionControllerEventName.click, () => this.fire('buttonClick'));
        this.button.on(ActionControllerEventName.click, () => this.fire('ok', new ParentEvent('ok')));
        this.addObject(this.secondButton = new ButtonComponent({
            type: 'flat',
            size: new Vector3(6, 6, 1),
            sizePx: new Vector2(256, 256),
            bordRadius: 0.45,
            background: { color: BUTTON_PRIMARY_COLOR.getStyle() },
            text: {
                value: 'Start'.toUpperCase(),
                lineHeight: 12,
                style: { size: '16px', color: BUTTON_PRIMARY_TEXT_COLOR.getStyle(), family: 'Nunito', weight: '800' },
                margin: { top: 10, right: 45, bottom: 10, left: 45 },
            }
        }));
        this.secondButton.uiObject.visible = false;
        this.secondButton.on(ActionControllerEventName.click, () => this.fire('secondButtonClick'));
        this.buttonsWrapper = new Object3D();
        this.buttonsWrapper.position.y = -1;
        this.buttonsWrapper.position.z = 0.01;
        this.buttonsWrapper.add(this.button.uiObject);
        this.addObject(this.buttonsWrapper);
    }
    init(headerText, mainText, buttonVisible = true) {
        this.background.init();
        this.header.setText(headerText);
        this.text.setText(mainText);
        this.button.uiObject.visible = buttonVisible;
    }
    setText(mainText) {
        this.text.setText(mainText);
        this.setVisible(true);
    }
    setVisible(value) {
        this.uiObject.visible = value;
    }
    fadeTween(timeToWait = 1500, timeToFade = 1000, toYPosition = 5) {
        const oldPosition = this.uiObject.position.clone();
        const newPos = oldPosition.clone().add(new Vector3(0, toYPosition, 0));
        const tween = new Tween({ alpha: 0 }).to({ alpha: 1 }, timeToFade)
            .onUpdate((alpha) => {
            const currentPos = oldPosition.clone().lerp(newPos, alpha);
            this.uiObject.position.copy(currentPos);
        })
            .onComplete(() => {
            this.uiObject.position.copy(oldPosition);
            this.uiObject.visible = false;
            this.fire('ok');
            this.fire('buttonClick');
        });
        setTimeout(() => {
            tween.start();
        }, timeToWait);
    }
}
